// import React from 'react';
import { orderStatus } from '@silvergatedelivery/constants';
import { getStartEndForDeliveryTime } from 'utilities/format';
import { getTranslatedMealSlots } from 'utilities/translate';
import { sortOrder } from 'utilities/sorting';

const getOrderStatusProps = (status) => {
  return orderStatus.find(({ value }) => value === status);
};

const getMealName = (mealSlot) => {
  return getTranslatedMealSlots().find(({ value }) => value === mealSlot).label;
};

// // TODO: query based on the current view + status
export const getOrderEvents = (inOrders = [], elders = [], options = {}) => {
  const { showElderName = true } = options;
  const events = inOrders.sort(sortOrder).map((item) => {
    const mealName = getMealName(item.mealSlot);
    const {
      color,
      // label: statusLabel,
    } = getOrderStatusProps(item.status);
    // const title = `[${statusLabel}] ${item.elder.name} (${item.restaurant.name})`;
    const elder = elders.find((elder) => elder.id === item.elderId);
    let elderName = elder?.name || item.elder.name;
    if (elder && item.elderId !== item.elder.id) {
      elderName += `-${elder.linkGroupName}`;
    }
    const title = showElderName ? `${elderName} (${item.restaurant.name})` : item.restaurant.name;
    // item.mealName = mealName;

    const { start, end } = getStartEndForDeliveryTime(item.deliveryBy);
    return {
      title,
      start,
      end,
      // color,
      backgroundColor: color,
      extendedProps: {
        type: 'order',
        data: item,
        mealName,
        description: '',
      },
    };
  });

  return events;
};
